export default __webpack_public_path__ + "static/media/ref_banner.a8490fe9.png";